import styles from './index.module.sass';
import { ReactComponent as IconSpin } from 'assets/icon_spin.svg';

const Spin = () => {
  return (
    <div className={styles.spin}>
      <IconSpin />
    </div>
  );
};

export default Spin;
